import * as React from "react";
// import logo from "../../../airplx-logo-transparent-square-no-text.png";
const logo = "/airplx-logo-transparent-square-no-text.png";
import { Box, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useFeatureFlags } from "../../containers/FeatureFlagsContainer";

export const Maintenance: React.FC<{}> = () => {
  const { t } = useTranslation();
  const { maintenanceEndTime } = useFeatureFlags();

  return (
    <Box
      alignItems="center"
      sx={{
        maxWidth: 600,
        margin: "auto",
        border: "8px solid black",
        borderRadius: 3,
        p: 3,
        mt: "10%",
      }}
    >
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="center"
        spacing={2}
      >
        <Stack
          direction="row"
          spacing={1}
          justifyContent="center"
          alignContent="center"
        >
          <img src={logo} style={{ width: 50 }} />
          <Typography align="center" variant="h4">
            {t('screens.maintenance.title')}
          </Typography>
        </Stack>
        <Typography variant="subtitle2">
          {t('screens.maintenance.message', { endTime: maintenanceEndTime })}
        </Typography>
      </Stack>
    </Box>
  );
};
